import { mapGetters, mapActions } from 'vuex'
import { metaInfoBuilder } from '../utilities'
import { PAGES } from '../content-types';
const type = PAGES.NEWS

export const NewsPageComponent = {
  name: 'PageComponent',
  computed: {
    ...mapGetters('prismic', ['getPage', 'getBlock', 'getAlternateLanguages']),
    ...mapGetters('konami', ['code', 'overlay']),
    news() {
      //   return this.page ? {
      //     main: this.page.main,
      //     content: this.page.content,
      //     konami: this.page.konami
      //   } : { main: null, content: [], konami: null }
      return this.page
    }
  },
  methods: {
    ...mapActions('prismic', ['setPage']),
    ...mapActions('konami', ['setCode', 'setOverlay'])
  },
  async serverPrefetch() {
    await this.setPage({ type, uid: this.$route.params.uid })
      .then(() => {
        const page = this.getPage({ uid: this.$route.params.uid, type })
        this.setCode({ code: page && page.konami ? page.konami.code : null })
        this.setOverlay({ overlay: !!(page && page.konami && page.konami.code) })
        this.page = page
      })
  },
  created() {
    this.setPage({ type, uid: this.$route.params.uid })
      .then(() => {
        const page = this.getPage({ uid: this.$route.params.uid, type })
        this.setCode({ code: page && page.konami ? page.konami.code : null })
        this.setOverlay({ overlay: !!(page && page.konami && page.konami.code) })
        this.page = page
      })
  },
  data() {
    return {
      page: null
    }
  },
  metaInfo() {
    const page = this.page
    return page ? metaInfoBuilder(page, this.$route, this.getAlternateLanguages({type, uid: this.$route.params.uid})) : {}
  },
}
